import Link from "next/link";
import { ChevronRight, Store } from "lucide-react";

import { Button } from "@/components/ui/button";
import { FilterPanel, type FilterField } from "@/components/blocks/FilterPanel";
import { formatPublicCategoryLabel } from "@/features/public-site/public-site.utils";
import type { ShopFiltersCardProps } from "@/features/shop/components/shop-page.types";

export function ShopFiltersCard({
  selectedCategory,
  categoryCounts,
  onCategoryChange,
}: ShopFiltersCardProps) {
  const fields: FilterField[] = [
    {
      id: "category",
      type: "option-list",
      label: "Category",
      value: selectedCategory,
      allowClear: true,
      onChange: (value) =>
        onCategoryChange(value as ShopFiltersCardProps["selectedCategory"]),
      options: categoryCounts.map((item) => ({
        label: formatPublicCategoryLabel(item.category),
        value: item.category,
        count: item.count,
      })),
    },
  ];

  return (
    <FilterPanel
      title="Filters"
      description="Refine product results"
      fields={fields}
      onReset={() => onCategoryChange("")}
      footer={
        <Button
          asChild
          className="w-full justify-start rounded-xl bg-emerald-600 text-white hover:bg-emerald-700"
        >
          <Link href="/shop/store-list">
            <Store className="mr-1 h-4 w-4" />
            Store Locations
            <ChevronRight className="ml-auto h-4 w-4" />
          </Link>
        </Button>
      }
    />
  );
}
